import { Update } from '@ngrx/entity';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { BaseOrderAction } from './order.action';
import { BaseOrderResponse, IBaseOMSOrder } from '../../../modules/order';
import { OrderPlaceChange, OrderPlaceState } from '../../../modules/order';
import { IBaseOrderEntity, IOMSOrderGetRespons } from '../../../modules/order';

export const OmsAction = createActionGroup({
	source: 'oms',
	events: {
		...BaseOrderAction,
		load: props<{ checkOrderPlace?: boolean }>(),
		set: props<{ value: IOMSOrderGetRespons; checkOrderPlace?: boolean }>(),
		loadOms: emptyProps(),
		updateMany: props<{ ids: string[]; changes: Partial<IBaseOrderEntity> }>(),
		createOms: props<{ newOrder: IBaseOrderEntity; sendingOrder: IBaseOMSOrder; draftId?: string }>(),
		createdOms: props<{ value: Update<IBaseOrderEntity> }>(),
		updateOms: props<{ newOrder: IBaseOrderEntity; sendingOrder: IBaseOMSOrder }>(),
		updatedOms: props<{ value: IBaseOrderEntity }>(),
		requestDone: props<{ value?: BaseOrderResponse }>(),
		deleteOms: props<{ id: string }>(),
		deletedOms: props<{ value: BaseOrderResponse }>(),
		createOmsByDraft: props<{ draft: IBaseOrderEntity }>(),
		reloadOrdersForInProgress: emptyProps(),
		updateOrderPlaces: props<{ values: OrderPlaceChange[] }>(),
		getOrderPlacesAndSubscribeTols: props<{ ids: string[] }>(),
		pushOrderPlaces: props<{ ids: string[] }>(),
		checkOrderPlaceToUpdate: props<{ ids?: string[]; state: OrderPlaceState }>(),
		//---------------------option----------------------------
		createOptionOms: props<{ newOrder: IBaseOrderEntity; sendingOrder: IBaseOMSOrder; draftId?: string }>(),
		createdOptionOms: props<{ value: Update<IBaseOrderEntity> }>(),
		updateOptionOms: props<{ newOrder: IBaseOrderEntity; sendingOrder: IBaseOMSOrder }>(),
		updatedOptionOms: props<{ value: IBaseOrderEntity }>(),
		deleteOptionOms: props<{ id: string }>(),
		deletedOptionOms: props<{ value: BaseOrderResponse }>()
	}
});
